import {
  CREATE_COLLECTION_ITEM,
  CREATE_COLLECTION_ITEM_SUCCESS,
  CREATE_COLLECTION_ITEM_ERROR,
  UPDATE_COLLECTION_ITEM_STATE,
} from "../actions";

export const createCollectionItem = (newRecord, history, id) => ({
  type: CREATE_COLLECTION_ITEM,
  payload: { newRecord, history, id }
});

export const createCollectionItemSuccess = (collectionItemSaved) => ({
  type: CREATE_COLLECTION_ITEM_SUCCESS,
  payload: collectionItemSaved,
});

export const createCollectionItemError = (message) => ({
  type: CREATE_COLLECTION_ITEM_ERROR,
  payload: { message },
});

export const updateCollectionItemState = (updatedValues) => ({
  type: UPDATE_COLLECTION_ITEM_STATE,
  payload: { updatedValues }
});